import React, { Fragment, useEffect, useState } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { saveServicesDataAsync, hideMessage } from "../../utils/customer/servicesSlice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import Button from "../UniversalComponents/DefaultButton";
import BasicSelect from "../Task/BasicSelect";
import {
  useAddConfigureServicesMutation,
  useAddUpdateCustomerServiceMutation,
  useAddupdateOrgServicesMutation,
  useGetOrgServicesQuery,
} from "../../utils/customer/customerTaskTable";
import { ReactComponent as BackIcon } from "../../assets/images/icons/BackIcon.svg";
import InputComponent from "../UniversalComponents/InputComponent";
import { pushAlert } from "../../utils/alertSlice";
import ClickAwayListener from "react-click-away-listener";
import { flattenTree } from "../../utils/utilityFunctions/stringUtility";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import BooleanSelect from "../UniversalComponents/BooleanSelect";
import LabelComponent from "../UniversalComponents/LabelComponent";
import TextAreaComponent from "../UniversalComponents/TextAreaComponent";

const ServicesModal = ({ isOpen, onClose, refetchCustomerData }) => {
  const token = getUserToken();
  const { id } = useParams();
  const customerId = parseInt(id);
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const message = useSelector((state) => state.customerServices.message);
  const showMessage = useSelector((state) => state.customerServices.showMessage);

  const [isAddMode, setIsAddmode] = useState(false);
  const [subServices, setSubServices] = useState([]);
  const [editableIndex, setEditableIndex] = useState(null);
  const [formErrors, setFormErrors] = useState({
    service_id: "",
  });
  const [formData, setFormData] = useState({
    service_id: "",
    sub_service_id: "",
    status: "",
    service_code: "",
  });

  const [newService, setNewService] = useState({ service_name: "", description: "" });
  const [newServiceError, setNewServiceError] = useState(false);
  const [editServiceId, setEditServiceId] = useState(null);

  const [subServiceOptions, setSubServicesOptions] = useState([]);

  const AddServiceValidationRules = {
    service_id: {
      required: true,
      errorMessage: "Service is required.",
    },
  };

  const configServiceValidationRules = {
    service_id: {
      required: true,
      errorMessage: "Service is required.",
    },
    sub_service_id: {
      required: false,
      errorMessage: "Sub Service is required",
    },
    service_code: {
      required: false,
      errorMessage: "Service Code is required",
    },
    status: {
      required: true,
      errorMessage: "Status is required",
    },
  };

  const [validationRules, setValidationRules] = useState(
    isAddMode ? AddServiceValidationRules : configServiceValidationRules
  );

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleFieldChange = (e) => {
    handleChange(e);

    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const requiredFields = ["service_id"];
    const errors = {};
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = "Cannot be left blank.";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const [addOrgService, { isLoading, data }] = useAddupdateOrgServicesMutation();
  const { data: allOrgServices, refetch: refetchServiceData } = useGetOrgServicesQuery({ token: token });

  const handleOrgServiceSave = async (event) => {
    event.preventDefault();

    // const formValid = isFormValid();
    setNewServiceError(false);
    if (!newService.service_name) {
      // dispatch(pushAlert({ visible: true, message: "Service name is required", type: "danger" }));
      setNewServiceError(true);
      return;
    }

    let servicePayload = {
      service_name: newService.service_name,
      description: newService.description,
      sub_services: subServices,
    };

    if (editServiceId) {
      servicePayload.id = editServiceId;
    }
    try {
      const response = await addOrgService({ servicePayload, token });
      if (response?.data?.success) {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
        await refetchCustomerData();
        await refetchServiceData();
        setIsAddmode(false);
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      console.error("Error saving service:", error);
      dispatch(pushAlert({ visible: true, message: "Failed to save service", type: "danger" }));
    }
  };

  const [addCustomerService, {}] = useAddUpdateCustomerServiceMutation();

  const handleCustomerServiceSave = async (event) => {
    event.preventDefault();

    const formValid = isFormValid();
    if (!formValid) {
      return;
    }

    let CustomerServicePayload = {
      // service_id: formData.service_id,
      service_code: formData.service_code,
      descriptions: formData.description,
      status: formData.status,
      customer_id: customerId,
      service_id: formData.service_id,
      sub_service_id: formData.sub_service_id,
    };

    // flattenTree(allOrgServices?.data, "sub_services")?.forEach((service) => {
    //   if (service.id === formData.service_id) {
    //     CustomerServicePayload.sub_service_id = service.id;
    //     CustomerServicePayload.service_id = service.parent_service_id ? service.parent_service_id : service.id;
    //   }
    // });

    try {
      const response = await addCustomerService({ CustomerServicePayload, token });
      if (response?.data?.success) {
        dispatch(pushAlert({ visible: true, message: response?.data?.message, type: "success" }));
        onClose();
      } else {
        dispatch(pushAlert({ visible: true, message: response?.data?.message, type: "danger" }));
      }

      await refetchCustomerData();
    } catch (error) {
      console.error("Error updating customer service:", error);
      dispatch(pushAlert({ visible: true, message: error.message || "An error occurred", type: "danger" }));
    }
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  const optionList = allOrgServices?.data?.map((eachItem) => ({
    label: eachItem?.name,
    value: eachItem?.id,
    // children: eachItem?.sub_services?.map((eachTask) => ({
    //   label: eachTask?.name,
    //   value: eachTask?.id,
    // })),
  }));

  const handleBasicFieldChange = (e) => {
    const { value, name, id } = e.target;
    console.log(e.target.value, "helowwwwww");

    if (name === "service_id") {
      const subServices = allOrgServices?.data?.filter((eachItem) => eachItem.id === value)[0]?.sub_services;
      setSubServicesOptions(subServices);
      if (subServices.length > 0)
        setValidationRules({
          ...validationRules,
          sub_service_id: { required: true, errorMessage: "Sub Service is required" },
        });
      else setValidationRules({ ...validationRules, sub_service_id: { required: false, errorMessage: "" } });
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "service_id" && { sub_service_id: "" }),
    }));
    console.log(formData, "hellloforkmmmm");
  };

  const handleAddServices = () => {
    setIsAddmode((prev) => !prev);
  };

  const handleNewServiceChange = (e) => {
    const { name, value } = e.target;
    setNewServiceError(false);
    if (name === "description" || value.length < 21) setNewService((prev) => ({ ...prev, [name]: value }));
  };

  const statusOption = [
    {
      label: "Active",
      value: "true",
    },
    {
      label: "Inactive",
      value: "false",
    },
  ];

  // const handleStatus = (e) => {
  //   const { name, value } = e.target;

  //   const selectedStatusOption = statusOption.find((option) => option.value === value);
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: selectedStatusOption ? selectedStatusOption?.label : value,
  //   }));
  // };

  const handleSubServiceChange = (index, value) => {
    if (value.length < 21) {
      const updatedSubServices = [...subServices];
      updatedSubServices[index] = value;
      setSubServices(updatedSubServices);
    }
  };

  const handleEditService = (data) => {
    setIsAddmode(true);
    setNewService({ service_name: data.label });
    setEditServiceId(data.value);
    const subServices = allOrgServices?.data?.filter((eachItem) => eachItem.id === data.value)[0]?.sub_services;
    setSubServices(subServices.map((eachItem) => eachItem.name));

    handleBasicFieldChange({ target: { value: data.value, name: "service_id" } });
  };

  const handleAddSubService = (event) => {
    if (event.key === "Enter" || event.type === "click") {
      event.preventDefault();

      if (newService.sub_service.trim() !== "") {
        setSubServices([...subServices, newService.sub_service]);

        setNewService({ ...newService, sub_service: "" });
      }
    }
  };

  const handleEditSubService = (index) => {
    setEditableIndex(index);
  };

  const handleDeleteSubService = (index) => {
    const updatedSubServices = subServices.filter((_, i) => i !== index);
    setSubServices(updatedSubServices);
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.target.blur();
      setEditableIndex(null);
    }
  };

  return (
    <CustomDrawer open={isOpen} onClose={onClose}>
      <div className="h-full  bg-white border font-popins overflow-hidden flex flex-col gap-2">
        <div className=" flex items-center  py-3 px-3 border-b border-BECBD3 ">
          {isAddMode && (
            <i
              className="bi bi-arrow-left cursor-pointer mr-2"
              onClick={() => {
                setSubServices([]);
                setNewService({ service_name: "", description: "" });
                setIsAddmode(false);
              }}
            ></i>
          )}
          <h3 className="text-lg font-medium text-434852">{isAddMode ? "Add" : "Configure"} Service</h3>
          <button
            onClick={onClose}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only">Close modal</span>
          </button>
        </div>

        {isAddMode ? (
          <form className="flex flex-col grow min-h-0 overflow-auto" onSubmit={handleOrgServiceSave}>
            <div className="px-3 grow min-h-0">
              {/* service name */}
              <div className="mb-1">
                <LabelComponent
                  labelText="Service Name"
                  htmlFor="service_name"
                  size="medium"
                  isMandatory
                  error={newServiceError}
                />
                <InputComponent
                  type="text"
                  name="service_name"
                  value={newService.service_name}
                  error={newServiceError}
                  mandatory
                  onChange={handleNewServiceChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="mb-1">
                {subServices.map((sub, index) => (
                  <div key={index} className="flex justify-between items-center gap-2 mb-1">
                    <InputComponent
                      onClick={() => handleEditSubService(index)}
                      inputClassName={`!rounded-full`}
                      value={sub}
                      onBlur={() => {
                        sub.length < 1 ? handleDeleteSubService(index) : setEditableIndex(null);
                      }}
                      onChange={(e) => handleSubServiceChange(index, e.target.value)}
                      disabled={editableIndex !== index}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      clickFocus={editableIndex === index}
                      icon={
                        <i
                          className={`bi bi-pencil-fill cursor-pointer transition-all ${editableIndex === index ? "invisible" : "visible"}`}
                          onClick={() => handleEditSubService(index)}
                        />
                      }
                    />
                    {!subServiceOptions.find((eachItem) => eachItem.name === sub) && (
                      <button
                        type="button"
                        className="flex items-center justify-center"
                        onClick={() => handleDeleteSubService(index)}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    )}
                  </div>
                ))}
              </div>

              {/* sub service */}
              <div className="mb-1">
                <LabelComponent labelText={"Sub Service"} htmlFor="sub_service" size="medium" />
                <InputComponent
                  type="text"
                  // inputClassName="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B active:border active:border-DFE2E5 text-gray-900 text-xs block w-full"
                  name="sub_service"
                  value={newService.sub_service}
                  onChange={handleNewServiceChange}
                  onKeyDown={handleAddSubService}
                  error="Error"
                  icon={
                    newService.sub_service ? <i onClick={handleAddSubService} className="bi bi-arrow-right" /> : null
                  }
                />
              </div>

              {/* description */}
              <div className="mb-1">
                <LabelComponent labelText={"Description"} htmlFor="description" size="medium" />
                <TextAreaComponent
                  rows={3}
                  name="description"
                  onChange={handleNewServiceChange}
                  value={newService.description}
                  showResizer
                />
              </div>
            </div>

            <div className="bg-white py-4 pr-3 flex justify-end text-md w-full border-t border-DFE2E5 mt-auto">
              <div className="px-2 gap-3 flex">
                <Button variant={"secondary"} onClick={onClose}>
                  CANCEL
                </Button>

                <Button variant={"primary"} type={"submit"}>
                  SAVE
                </Button>
              </div>
            </div>
          </form>
        ) : (
          <form onSubmit={handleCustomerServiceSave} className="flex flex-col grow min-h-0 overflow-auto">
            <div className="px-3 grow min-h-0">
              {/* Services */}
              <div className="mb-1 ">
                <LabelComponent
                  labelText={"Services"}
                  htmlFor="service_id"
                  size="medium"
                  isMandatory
                  // error={errors.service_id}
                />

                <BasicSelect
                  options={optionList}
                  // onClick={handleBasicFieldChange}
                  showSearch
                  onChange={handleBasicFieldChange}
                  selectedOptions={
                    flattenTree(optionList)?.filter((option) => option.value === formData.service_id) || null
                  }
                  addButton
                  name="service_id"
                  addButtonLabel={"Add New Service"}
                  addButtonAction={handleAddServices}
                  label="Service"
                  isEditList
                  editListHandler={(data) => handleEditService(data)}
                  size="medium"
                  isError={errors.service_id}
                />
              </div>

              {/* sub service  */}
              {Boolean(subServiceOptions.length) && (
                <div className="mb-1 ">
                  <LabelComponent labelText={"Sub Services"} htmlFor="sub_service_id" size="medium" isMandatory />

                  <BasicSelect
                    options={subServiceOptions.map((eachItem) => ({
                      label: eachItem.name,
                      value: eachItem.id,
                    }))}
                    // onClick={handleBasicFieldChange}
                    showSearch
                    onChange={handleBasicFieldChange}
                    selectedOptions={
                      subServiceOptions
                        ?.filter((option) => option.id === formData.sub_service_id)
                        .map((eachItem) => ({
                          label: eachItem.name,
                          value: eachItem.id,
                        })) || null
                    }
                    name="sub_service_id"
                    size="medium"
                    isError={errors.sub_service_id}
                    // addButton
                    // addButtonLabel={"+ Add Service"}
                    // addButtonAction={handleAddServices}
                    label="Sub Service"
                    // isEditList
                    // editListHandler={(data) => handleEditService(data)}
                  />
                </div>
              )}

              {/* description */}
              <div className="mb-1">
                <LabelComponent labelText={"Description"} htmlFor="description" size="medium" />
                <TextAreaComponent
                  name="description"
                  onChange={handleBasicFieldChange}
                  value={formData.description}
                  showResizer
                />
              </div>

              {/* service code */}
              <div className="mb-1">
                <LabelComponent labelText="Service Code" htmlFor="service_code" size="medium" />
                <InputComponent
                  type="text"
                  id={"service_code"}
                  name={"service_code"}
                  onChange={handleBasicFieldChange}
                  value={formData?.service_code}
                />
              </div>

              {/* status */}
              <div className="relative mb-1">
                <LabelComponent
                  labelText={"Status"}
                  htmlFor="status"
                  size="medium"
                  isMandatory
                  // error={errors.status}
                />
                <BooleanSelect
                  options={statusOption}
                  name="status"
                  label="Status"
                  value={formData.status}
                  // selectedOptions={booleanArr?.filter((option) => option.value === formData.status1) || null}
                  onChange={handleBasicFieldChange}
                  size="medium"
                  isError={errors.status}
                />
              </div>
            </div>

            <div className="bg-white py-4 pr-3 flex justify-end text-md w-full border-t border-DFE2E5 ">
              <div className="px-2 gap-3 flex">
                <Button variant={"secondary"} onClick={onClose}>
                  CANCEL
                </Button>

                <Button variant={"primary"} type={"submit"}>
                  SAVE
                </Button>
              </div>
            </div>
          </form>
        )}
      </div>
    </CustomDrawer>
  );
};
export default ServicesModal;
